// extracted by mini-css-extract-plugin
export default {"root":"plain-search-dropdown_root__VJNGo","placeHolderShimmer":"plain-search-dropdown_placeHolderShimmer__c1oUb"};